/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useMemo } from "react";
import { useGetResourceUpdateStatusCounts } from "~/views/resources/hooks";
import { updateStatusCardTypes } from "../../const";
import { ResourceUpdateStatus } from "../../types";
import { getUpdateStatusDetails } from "../../utils";
import { StatusCard } from "../StatusCard";
import { CardsWrap } from "./CardsWrap";

type Props = {
  activeStatuses?: ResourceUpdateStatus[];
  onClick: (status: ResourceUpdateStatus) => void;
};

export function StatusCards({ activeStatuses, onClick }: Props) {
  const { data, loading } = useGetResourceUpdateStatusCounts();

  const countsByStatus = useMemo(
    () => Object.fromEntries(data.map((item) => [item.status, item.count])),
    [data]
  );

  return (
    <CardsWrap>
      {updateStatusCardTypes.map((status) => (
        <StatusCard
          key={status}
          title={getUpdateStatusDetails(status).label}
          count={countsByStatus[status] ?? 0}
          status={status}
          loading={loading}
          active={activeStatuses?.includes(status)}
          onClick={onClick}
        />
      ))}
    </CardsWrap>
  );
}
